
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MFGTransactionLossDialog extends Serenity.EntityDialog<MFGTransactionLossRow, any> {
        protected getFormKey() { return MFGTransactionLossForm.formKey; }
        protected getIdProperty() { return MFGTransactionLossRow.idProperty; }
        protected getLocalTextPrefix() { return MFGTransactionLossRow.localTextPrefix; }
        protected getNameProperty() { return MFGTransactionLossRow.nameProperty; }
        protected getService() { return MFGTransactionLossService.baseUrl; }
        protected getDeletePermission() { return MFGTransactionLossRow.deletePermission; }
        protected getInsertPermission() { return MFGTransactionLossRow.insertPermission; }
        protected getUpdatePermission() { return MFGTransactionLossRow.updatePermission; }

        protected form = new MFGTransactionLossForm(this.idPrefix);

    }
}